(function () {
  if (window.__hsAvailabilityInit) return;
  window.__hsAvailabilityInit = true;

  function readData(indicator) {
    var sectionRoot =
      indicator.closest('[id^="ProductInfo-"]') ||
      indicator.closest('[data-section-id]') ||
      indicator.closest('.shopify-section');
    if (!sectionRoot) return null;
    var dataEl = sectionRoot.querySelector('[data-hs-availability-data]');
    if (!dataEl) {
      var sid = sectionRoot.id ? sectionRoot.id.replace(/^ProductInfo-/, '') : sectionRoot.getAttribute('data-section-id');
      if (sid) dataEl = document.querySelector('[data-hs-availability-data="' + sid + '"]');
    }
    if (!dataEl) return null;
    try {
      var data = JSON.parse(dataEl.textContent);
      data.__sectionRoot = sectionRoot;
      return data;
    } catch (e) {
      return null;
    }
  }

  function determineState(data, variantId) {
    if (!variantId) return null;
    var v = data.variants[String(variantId)];
    if (!v) return null;
    if (!v.available) return 'out_of_stock';
    if (v.managed && v.policy !== 'continue' && v.quantity > 0 && v.quantity <= data.threshold) return 'low_stock';
    return 'in_stock';
  }

  function getActiveVariantId(sectionRoot) {
    try {
      var url = new URL(window.location.href);
      var v = url.searchParams.get('variant');
      if (v) return v;
    } catch (e) {}
    var buy = sectionRoot.querySelector('.f-product-single__block--buy_buttons input[name="id"]');
    if (buy && buy.value) return buy.value;
    var any = sectionRoot.querySelector('input[name="id"]');
    return any && any.value ? any.value : null;
  }

  function render(indicator, data, state) {
    if (!state) return;
    var def = data.states[state];
    if (!def) return;
    indicator.className = indicator.className.replace(/\bhs-availability--\S+/g, '').trim() + ' hs-availability hs-availability--' + state;
    indicator.setAttribute('data-availability-state', state);
    var textSpan = indicator.querySelector('.hs-availability__text');
    if (!textSpan) return;
    while (textSpan.firstChild) textSpan.removeChild(textSpan.firstChild);
    var strong = document.createElement('strong');
    strong.textContent = def.label == null ? '' : String(def.label);
    textSpan.appendChild(strong);
    if (def.sub && String(def.sub).length) {
      var sep = document.createElement('span');
      sep.className = 'hs-availability__sep';
      sep.textContent = '·';
      textSpan.appendChild(sep);
      textSpan.appendChild(document.createTextNode(' ' + String(def.sub)));
    }
  }

  function updateAll() {
    var indicators = document.querySelectorAll('.hs-availability');
    for (var i = 0; i < indicators.length; i++) {
      var indicator = indicators[i];
      var data = readData(indicator);
      if (!data) continue;
      var id = getActiveVariantId(data.__sectionRoot);
      var state = determineState(data, id);
      if (state) render(indicator, data, state);
    }
  }

  function determineStateFromVariant(data, variant) {
    if (!variant) return null;
    if (!variant.available) return 'out_of_stock';
    var managed = variant.inventory_management === 'shopify';
    var policy = variant.inventory_policy;
    var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
    if (qty == null) {
      var inv = window.FoxInventories && window.FoxInventories[data.productId] && window.FoxInventories[data.productId][variant.id];
      if (inv && typeof inv.quantity !== 'undefined') {
        qty = parseInt(inv.quantity, 10);
        if (!policy) policy = inv.policy;
      }
    }
    if (managed && policy !== 'continue' && qty != null && qty > 0 && qty <= data.threshold) return 'low_stock';
    return 'in_stock';
  }

  var subscribed = {};
  function attachFoxEvents() {
    if (!window.FoxThemeEvents || typeof window.FoxThemeEvents.subscribe !== 'function') return false;
    var indicators = document.querySelectorAll('.hs-availability');
    for (var i = 0; i < indicators.length; i++) {
      var indicator = indicators[i];
      var data = readData(indicator);
      if (!data) continue;
      var key = String(data.productId);
      if (subscribed[key]) continue;
      subscribed[key] = true;
      (function (pid, ind) {
        window.FoxThemeEvents.subscribe(pid + '__VARIANT_CHANGE', function (variant) {
          var freshData = readData(ind) || data;
          if (!variant) {
            render(ind, freshData, 'out_of_stock');
            return;
          }
          var state = determineStateFromVariant(freshData, variant) || determineState(freshData, variant.id);
          if (state) render(ind, freshData, state);
        });
      })(key, indicator);
    }
    return true;
  }

  function scheduleUpdates() {
    setTimeout(updateAll, 50);
    setTimeout(updateAll, 250);
    setTimeout(updateAll, 600);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.matches && (t.matches('input[type="radio"]') || t.matches('select') || t.matches('input[name="id"]'))) {
      scheduleUpdates();
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.closest && t.closest('label, input[type="radio"], [data-variant], .variant-picker, select, button[name="id"]')) {
      scheduleUpdates();
    }
  });

  window.addEventListener('popstate', scheduleUpdates);
  window.addEventListener('hashchange', scheduleUpdates);

  var lastUrl = window.location.href;
  setInterval(function () {
    if (window.location.href !== lastUrl) {
      lastUrl = window.location.href;
      updateAll();
    }
    attachFoxEvents();
  }, 400);

  if (!attachFoxEvents()) {
    var tries = 0;
    var waitFor = setInterval(function () {
      tries++;
      if (attachFoxEvents() || tries > 60) clearInterval(waitFor);
    }, 100);
  }

  var bodyObserver = new MutationObserver(function (muts) {
    var rescan = false;
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.classList && n.classList.contains('hs-availability') || (n.querySelector && n.querySelector('.hs-availability')))) {
          rescan = true;
          break;
        }
      }
      if (rescan) break;
    }
    if (rescan) {
      attachFoxEvents();
      updateAll();
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateAll();
      attachFoxEvents();
    });
  } else {
    updateAll();
    attachFoxEvents();
  }
})();
